<template>
  <v-dialog
    v-model="isModalOpen"
    max-width="480px"
    content-class="fixed-height-sm"
  >
    <modal-card title="Assign To" fixed padding @close="isModalOpen = false">
      <v-autocomplete
        v-model="selectedUserId"
        :items="guestUsers"
        item-text="label"
        item-value="value"
        label="Select user"
        :search-input.sync="search"
        @change="search = ''"
      >
        <template v-slot:item="{ item }">
          <div class="d-flex align-center">
            <avatar size="micro" :img="item.photo" class="mr-2" />
            {{ item.label }}
          </div>
        </template>
      </v-autocomplete>

      <template #actions>
        <v-btn
          color="appMain"
          :disabled="!selectedUserId || saving"
          :loading="saving"
          @click="assign"
        >
          Assign
        </v-btn>
      </template>
    </modal-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ROLES } from '@/access/roles';
import Avatar from '@/components/basic/avatar/Avatar';

export default {
  name: 'AssignContactsModal',
  components: { Avatar },
  props: {
    value: Boolean,
    contacts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedUserId: null,
      search: '',
      saving: false,
    };
  },
  computed: {
    ...mapGetters('users', ['usersOptions']),
    guestUsers() {
      return this.usersOptions.filter((u) => u.role === ROLES.GUEST);
    },
    isModalOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    isModalOpen(val) {
      if (!val) {
        this.selectedUserId = null;
        this.search = '';
      }
    },
  },
  methods: {
    ...mapActions('users', ['loadUsers']),
    ...mapActions(['updateContact']),
    async assign() {
      if (!this.selectedUserId) return;
      this.saving = true;

      try {
        await Promise.all(
          this.contacts.map((c) =>
            this.updateContact({
              contactId: c.con_id,
              params: {
                assigned_to: {
                  add: [this.selectedUserId],
                  remove: c.assigned_to || [],
                },
              },
              skipRefetch: true,
            })
          )
        );
        this.$emit('saved');
        this.isModalOpen = false;
      } finally {
        this.saving = false;
      }
    },
  },
  mounted() {
    this.loadUsers();
  },
};
</script>
